import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {AchooInputComponent} from '../achoo-input/achoo-input.component';
import {ValidationHandlerService} from '../validation-handler.service';
import {StringUtils} from '../../utils/string.utils';

@Component({
  selector: 'achoo-checkbox',
  templateUrl: './achoo-checkbox.component.html',
  styleUrls: ['./achoo-checkbox.component.scss']
})
export class AchooCheckboxComponent extends AchooInputComponent<any> implements OnInit {

  @Output()
  public selectEvent = new EventEmitter<any>();

  constructor(protected validationHandlerService: ValidationHandlerService) {
    super(validationHandlerService);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  onSelect(e) {
    this.selectEvent.emit(e);
  }

  haveLabel() {
    return this.label && StringUtils.trim(this.label) !== '';
  }

}



// WEBPACK FOOTER //
// ./src/app/core/achoo-checkbox/achoo-checkbox.component.ts